import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2C2C2C] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_cosy-commerce/artifacts/bln0ehzh_ChatGPT_Image_Feb_8__2026__08_25_25_PM-removebg-preview.png" 
                alt="Glow & Gather Candles" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-stone-400 text-sm leading-relaxed">
              Handcrafted candles made with love in the heart of Scotland. Bringing warmth and ambiance to your home.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-[#C5A059]">Quick Links</h4>
            <ul className="space-y-3">
              {['Shop', 'About', 'Contact'].map((link) => (
                <li key={link}>
                  <Link 
                    to={`/${link.toLowerCase()}`} 
                    className="text-stone-400 hover:text-[#C5A059] transition-colors text-sm"
                    data-testid={`footer-link-${link.toLowerCase()}`}
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-[#C5A059]">Categories</h4>
            <ul className="space-y-3">
              {['Candles', 'Snap Bars', 'Wax Melts', 'Wax Burners', 'Bundles'].map((cat) => (
                <li key={cat}>
                  <Link 
                    to={`/shop/${cat.toLowerCase().replace(' ', '-')}`} 
                    className="text-stone-400 hover:text-[#C5A059] transition-colors text-sm"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-[#C5A059]">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#C5A059]" />
                <a 
                  href="mailto:sarah@glowandgathercandles.co.uk" 
                  className="text-stone-400 hover:text-[#C5A059] transition-colors text-sm"
                  data-testid="footer-email"
                >
                  sarah@glowandgathercandles.co.uk
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#C5A059]" />
                <a 
                  href="https://wa.me/447703390971" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-stone-400 hover:text-[#C5A059] transition-colors text-sm"
                  data-testid="footer-whatsapp"
                >
                  WhatsApp: 07703 390971
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Facebook className="w-4 h-4 text-[#C5A059]" />
                <a 
                  href="https://www.facebook.com/glowandgathercandles" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-stone-400 hover:text-[#C5A059] transition-colors text-sm"
                  data-testid="footer-facebook"
                >
                  Follow us on Facebook
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#C5A059] mt-0.5" />
                <span className="text-stone-400 text-sm">
                  Scotland, United Kingdom
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-stone-500 text-sm">
            © {currentYear} Glow & Gather Candles. All rights reserved.
          </p>
          <p className="text-stone-500 text-sm font-cursive text-lg">
            Handmade with love
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
